
export enum Filter {
    All = 'All',
    Active = 'Active',
    Completed = 'Completed',
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/models/filter.ts